import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import successmessage from '../../../assets/SubscriptionImage/successmessage.png';
import { ToastContainer } from "react-toastify";

const SubscriptionSuccessModal = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/login');
  };

  useEffect(() => {
    const timer = setTimeout(handleRedirect, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (

    <div
      className="modal-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        backdropFilter: 'blur(2px)',
      }}
    >
        <ToastContainer/>
      <div
        className="modal-content"
        style={{
          width: '690px',
          height: '390px',
          backgroundColor: '#fff',
          borderRadius: '30px',
          padding: '40px 30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
        }}
      >
        <p style={{ fontSize: '16px', color: '#333', marginBottom: '20px' }}>
          You are being redirected to the login page...
        </p>

        <img
          src={successmessage}
          alt="Success"
          width="160"
          height="160"
          style={{ marginBottom: '20px' }}
        />

        <h2
          style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#000',
            margin: '0 0 12px',
          }}
        >
          Your store was successfully created with a paid subscription
        </h2>

      </div>
    </div>
  );
};

export default SubscriptionSuccessModal;